import { render, staticRenderFns } from "./PxCriterioUrgencia.vue?vue&type=template&id=533d016e&"
import script from "./PxCriterioUrgencia.vue?vue&type=script&lang=js&"
export * from "./PxCriterioUrgencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports